<template>
  <div>
    <Hero>
      <div class="mr-4">
        {{ $t('message.testDrive.chooseDateHeader') }}
        <img :src="require('@/assets/fa/spiral-calendar.svg')" width="22" height="22" class="mb-1" alt="" />
      </div>
      <template slot="description">{{ $t('message.testDrive.chooseDateDescription') }}</template>
    </Hero>
    <mobialis-form-with-validation v-slot="{ invalid, errors }" @onValidate="submit">
      <div v-if="Object.values(errors)[+!errorIndex]">
        <p class="error" v-if="Object.values(errors)[+!errorIndex].includes('The test drive date field is required')">
          {{ $t('message.testDrive.errorMessagePartOne') }}{{ $t('message.testDrive.errorMessagePartTwo')[0] }}
        </p>
      </div>
      <MobileDatePicker v-model="setDate" v-if="isAVRMobile" />
      <div v-else>
        <p class="error" v-if="desktopPickerError">
          {{ $t('message.testDrive.errorMessagePartOne') }}{{ $t('message.testDrive.errorMessagePartTwo')[0] }}
        </p>
        <h5 class="ml-1 my-4">{{ $t('message.testDrive.chooseDateSubheader1') }}</h5>
        <DesktopDatePicker @clicked="desktopClicked" class="date-container" />
      </div>
      <div v-if="Object.values(errors)[errorIndex]">
        <p class="error" v-if="Object.values(errors)[errorIndex].includes('The time of day field is required')">
          {{ $t('message.testDrive.errorMessagePartOne') }}{{ $t('message.testDrive.errorMessagePartTwo')[1] }}
        </p>
      </div>
      <h5 class="ml-1 my-4">{{ $t('message.testDrive.chooseDateSubheader2') }}</h5>
      <div v-for="(choice, index) in choices" :key="index">
        <MobialisFancyRadio
          class="radio-container"
          :disabled="timeSlotDisabled[index]"
          :textArray="[choices[index]]"
          name="time of day"
          v-model="setTimeOfDay"
          data-cy="timeOfDayOption"
        />
      </div>
      <mobialis-button class="cont-btn mt-5" type="submit" data-cy="submitBtn">{{
        $t('message.common.continue')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>
<script>
import moment from 'moment';
import Hero from '@/components/test-drive/Hero.vue';
import MobileDatePicker from '@/components/test-drive/MobileDatePicker.vue';
import DesktopDatePicker from '@/components/test-drive/DesktopDatePicker.vue';
import { AVAnalyticsEventTriggers } from '@/utils/enums';
import helperFunctions from '@/utils/helperFunctions';

export default {
  name: 'ChooseDate',
  components: {
    Hero,
    MobileDatePicker,
    DesktopDatePicker,
  },
  data() {
    return {
      testmodel: null,
      desktopPickerError: false,
      today: moment().format('YYYY/MM/D'),
      currentHour: moment().format('HH'),
    };
  },
  computed: {
    timeSlotDisabled() {
      if (!this.setDate) {
        return [true, true, true, true, true];
      }
      const holder = [false, false, false, false, false];
      if (this.setDate === this.today) {
        if (this.currentHour > 10) {
          holder[0] = true;
        }
        if (this.currentHour > 12) {
          holder[1] = true;
        }
        if (this.currentHour > 16) {
          holder[2] = true;
        }
        if (this.currentHour > 21) {
          holder[3] = true;
          holder[4] = true;
        }
      }
      return holder;
    },
    errorIndex() {
      return this.baseRoute === 'mobile' ? 1 : 0;
    },
    setTimeOfDay: {
      get() {
        return this.$store.state.testDrive.chosenTimeOfDay;
      },
      set(value) {
        this.$store.commit('testDrive/SET_CHOSEN_TIME_OF_DAY', value);
      },
    },
    setDate: {
      get() {
        return this.$store.state.testDrive.driveDate;
      },
      set(value) {
        this.$store.commit('testDrive/SET_DRIVE_DATE', value);
        // Need to manually trigger this input event for desktop
        // because it is not being captured by our global input event listener
        if (!this.isAVRMobile) {
          helperFunctions.sendAVAnalyticsEvent(this.$route.path, AVAnalyticsEventTriggers.INTERACTION, this.$store);
        }
      },
    },
    choices() {
      return this.$t('message.testDrive.timeOfDayChoices');
    },
  },
  mounted() {
    this.$store.commit('SET_LOADING', false);
  },
  methods: {
    submit(isValid) {
      this.desktopPickerError = !this.setDate;
      if (isValid && this.setDate) {
        this.$router.push({
          name: `drive-preferences-${this.baseRoute}`,
        });
      }
    },
    desktopClicked(value) {
      this.setDate = value;
    },
  },
};
</script>

<style scoped lang="scss">
.date-container {
  border: 0.5px solid rgba(206, 206, 206, 0.5);
  width: 200px;
  padding-left: 16px;
  padding-top: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
@media (min-width: $breakpoint-mobile) {
  .radio-container {
    width: 407px;
  }
}
</style>
